import { render, staticRenderFns } from "./NewBookingFlayer.vue?vue&type=template&id=29b7f2d7&"
import script from "./NewBookingFlayer.vue?vue&type=script&lang=js&"
export * from "./NewBookingFlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports